import { Zap } from 'lucide-react';
import { ASSETS, SPECS } from '../lib/products';
import Lineup from '../sections/Lineup';
import Marquee from '../components/Marquee';
import Footer from '../sections/Footer';

export default function ProductsPage() {
  return (
    <main data-testid="products-page" className="bg-cream min-h-screen">
      <div className="px-5 sm:px-8 pt-12 pb-6 max-w-6xl mx-auto grid md:grid-cols-[1fr_auto] gap-8 items-end">
        <div>
          <p className="font-cond text-xs tracking-[0.4em] text-cocoa/60">EVERY PACK. EVERY REP. GO BEYOND.</p>
          <h1 className="font-display text-7xl sm:text-9xl text-cocoa leading-none mt-2">THE <span className="stroke-text">SHOP</span></h1>
          <p className="text-sm text-cocoa/70 mt-4 max-w-xl">
            Multigrain protein chips, 50g pack, 15g protein, ₹50. Roasted not fried, plant based, no palm oil, no artificial colours. Minimum order 3 packets, shipping charges applicable. Two flavours live — a third chosen by you.
          </p>
        </div>
        <div className="rounded-[2rem] bg-cocoa px-8 py-6 border-2 border-cocoa shadow-[8px_8px_0_#E11D24] -rotate-1">
          <img src={ASSETS.logo} alt="PROKRISP" className="h-10 sm:h-12 object-contain" draggable="false" />
          <div className="flex flex-wrap gap-1.5 mt-4 max-w-xs">
            {SPECS.map((s) => <span key={s} className="rounded-full bg-kyellow text-cocoa px-2.5 py-1 text-[9px] font-black tracking-[0.15em] flex items-center gap-1"><Zap size={9} className="fill-cocoa" />{s}</span>)}
          </div>
        </div>
      </div>
      <Marquee />
      <Lineup showAll />
      <Footer />
    </main>
  );
}
